import { numeral } from '../numeral';

numeral.register('format', 'ordinal', {
	regexps: {
		format: /(o)/
	},

	format(value: number, format: string, roundingFunction: (x: number) => number) {
		const locale = numeral.locales[numeral.options.currentLocale];
		let ordinal = numeral.formats.includes(' o') ? ' ' : '';

		// check for space before
		format = format.replace(/\s?o/, '');

		ordinal += locale.ordinal(value);

		const output = numeral._.numberToFormat(value, format, roundingFunction);

		return output + ordinal;
	}
});
